/* Kit finder quiz (sections/wp-quiz.liquid). Steps: who → exp → love → place (only if a tile has a place question) → time (not for gifts) → results.
   Results: product cards from sections/wp-quiz-results.liquid, fetched on each chosen collection with Difficulty
   filters, best-selling first. Answers are saved as the cart attribute "Kit quiz". */
(() => {
  const root = document.querySelector('[data-wpq]');
  if (!root) return;
  const cfg = JSON.parse(root.querySelector('[data-wpq-config]').textContent);
  const $ = (s) => root.querySelector(s);
  const $$ = (s) => [...root.querySelectorAll(s)];
  const LEVELS = ['Easy', 'Intermediate', 'Detailed'];
  const HOURS = { Easy: '3–4 hours', Intermediate: '4–6 hours', Detailed: '8–10 hours' };
  const WHO = { me: 'For me', gift: 'Gift', together: 'Painting together' };
  const SHOW = 16;
  const MAX_PICKS = 3;

  let a = {};          // answers
  let trail = [];      // steps shown, for Back
  let placeFor = null; // interest that gets the place question

  const interest = (id) => cfg.interests.find((i) => i.id === id);
  const flow = () => {
    const s = ['who', 'exp', 'love'];
    if (placeFor) s.push('place');
    if (a.who !== 'gift') s.push('time');
    s.push('results');
    return s;
  };

  // experience + time → Difficulty values
  const levels = () => {
    if (a.exp === 'unsure') return ['Easy', 'Intermediate'];
    const e = { first: 0, few: 1, lot: 2 }[a.exp] ?? 0;
    const t = { evening: 0, evenings: 1, project: 2 }[a.time];
    if (t === undefined || t === e) return [LEVELS[e]];
    if (Math.abs(e - t) === 1) return [LEVELS[Math.min(e, t)], LEVELS[Math.max(e, t)]];
    return e === 0 ? ['Easy', 'Intermediate'] : ['Intermediate'];
  };

  const query = (lv, place) => {
    const p = new URLSearchParams();
    lv.forEach((l) => p.append('filter.p.m.custom.difficulty', l));
    if (place) p.append('filter.p.m.custom.place', place);
    p.set('sort_by', 'best-selling');
    return p;
  };
  const cache = {};
  const fetchSet = (handle, lv, place) => {
    const p = query(lv, place);
    p.set('section_id', 'wp-quiz-results');
    const url = `/collections/${handle}?${p}`;
    cache[url] = cache[url] || fetch(url).then((r) => r.text()).then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const meta = JSON.parse(doc.querySelector('[data-quiz-meta]')?.textContent || '{"count":0,"places":[]}');
      return { ...meta, cards: [...doc.querySelectorAll('[data-quiz-cards] > li')] };
    }).catch(() => ({ count: 0, places: [], cards: [] }));
    return cache[url];
  };

  // ---------- navigation ----------
  const show = (step, scroll = true) => {
    $$('.wpq-step').forEach((s) => s.classList.toggle('is-active', s.dataset.step === step));
    if (trail[trail.length - 1] !== step) trail.push(step);
    const f = flow();
    $('[data-wpq-bar]').style.width = `${Math.round(((f.indexOf(step) + 1) / f.length) * 100)}%`;
    $('[data-wpq-back]').hidden = trail.length < 2 || step === 'results';
    root.classList.toggle('is-done', step === 'results');
    const gift = a.who === 'gift';
    $$('[data-q-self],[data-self]').forEach((el) => { el.hidden = gift; });
    $$('[data-q-gift],[data-gift],[data-gift-only]').forEach((el) => { el.hidden = !gift; });
    if (step === 'place') loadPlaces();
    if (step === 'results') results();
    if (scroll) window.scrollTo({ top: root.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
  };
  const next = (from) => {
    const f = flow();
    show(f[f.indexOf(from) + 1]);
  };

  root.addEventListener('click', (e) => {
    const opt = e.target.closest('[data-answer]');
    const step = e.target.closest('.wpq-step')?.dataset.step;
    if (opt && step) {
      if (step === 'place') a.place = opt.dataset.answer === 'skip' ? null : opt.dataset.place;
      else a[step] = opt.dataset.answer;
      if (step === 'who' && a.who === 'gift') delete a.time;
      next(step);
      return;
    }
    const tile = e.target.closest('[data-interest]');
    if (tile) {
      const on = tile.getAttribute('aria-pressed') !== 'true';
      const picked = $$('[data-interest][aria-pressed="true"]');
      if (on && picked.length >= MAX_PICKS) picked[0].setAttribute('aria-pressed', 'false');
      tile.setAttribute('aria-pressed', String(on));
      $('[data-wpq-next]').disabled = !$$('[data-interest][aria-pressed="true"]').length;
      return;
    }
    if (e.target.closest('[data-wpq-next]')) {
      a.love = $$('[data-interest][aria-pressed="true"]').map((t) => t.dataset.interest);
      placeFor = a.love.map(interest).find((i) => i && i.place_q) || null;
      if (!placeFor) a.place = null;
      next('love');
      return;
    }
    if (e.target.closest('[data-wpq-back]')) {
      trail.pop();
      const prev = trail.pop();
      if (prev) show(prev);
      return;
    }
    if (e.target.closest('[data-wpq-restart]')) {
      a = {}; trail = []; placeFor = null;
      $$('[data-interest]').forEach((t) => t.setAttribute('aria-pressed', 'false'));
      $('[data-wpq-next]').disabled = true;
      show('who');
    }
  });

  // ---------- place step ----------
  const loadPlaces = () => {
    const q = placeFor.place_q;
    $('[data-place-q]').textContent = a.who === 'gift' ? q.replace(/your/g, 'their').replace(/for you/g, 'for them').replace(/you/g, 'they') : q;
    const box = $('[data-wpq-places]');
    const search = $('[data-wpq-place-search]');
    search.value = '';
    box.innerHTML = '<p class="wpq-loading">Loading…</p>';
    fetchSet(placeFor.handle, levels()).then((m) => {
      const places = m.places.length ? m.places : [];
      if (!places.length) { a.place = null; next('place'); return; }
      box.innerHTML = places.map((p, i) => `<button type="button" class="wpq-chip${i >= 16 ? ' is-more' : ''}" data-answer="pick" data-place="${p.replace(/"/g, '&quot;')}">${p.replace(/</g, '&lt;')}</button>`).join('');
      search.hidden = places.length <= 16;
    });
  };
  root.addEventListener('input', (e) => {
    if (!e.target.matches('[data-wpq-place-search]')) return;
    const q = e.target.value.trim().toLowerCase();
    const box = $('[data-wpq-places]');
    box.classList.toggle('is-searching', q !== '');
    box.querySelectorAll('.wpq-chip').forEach((c) => { c.hidden = q !== '' && !c.textContent.toLowerCase().includes(q); });
  });

  // ---------- results ----------
  const results = async () => {
    const lv = levels();
    const picks = a.love.map(interest).filter(Boolean);
    const grid = $('[data-wpq-grid]');
    const note = $('[data-wpq-note]');
    grid.innerHTML = '';
    note.hidden = true;
    $('[data-wpq-wait]').hidden = false;
    $('[data-wpq-title]').textContent = a.who === 'gift' ? 'Gift picks they’ll love' : 'Kits picked for you';
    const chips = [WHO[a.who], `${lv.join(' or ')} · about ${HOURS[lv[0]].split('–')[0]}–${HOURS[lv[lv.length - 1]].split('–')[1]}`, ...picks.map((p) => p.label)];
    if (a.place) chips.push(a.place);
    $('[data-wpq-summary]').innerHTML = chips.map((c) => `<li>${c.replace(/</g, '&lt;')}</li>`).join('');

    // place matches first (any level if none at this level), then each interest, interleaved
    let placeSet = null;
    let notes = [];
    if (a.place && placeFor) {
      placeSet = await fetchSet(placeFor.handle, lv, a.place);
      if (!placeSet.cards.length) {
        placeSet = await fetchSet(placeFor.handle, LEVELS, a.place);
        if (placeSet.cards.length) notes.push(`${a.place} designs come in other levels, so we included them too.`);
        else notes.push(`We don’t have a ${a.place} design yet. Here are similar kits.`);
      }
    }
    let sets = await Promise.all(picks.map((p) => fetchSet(p.handle, lv)));
    const seen = new Set();
    const out = [];
    const take = (li) => { const id = li.dataset.id; if (!id || seen.has(id) || out.length >= SHOW) return; seen.add(id); out.push(li); };
    (placeSet ? placeSet.cards : []).forEach(take);
    for (let i = 0; out.length < SHOW && i < 16; i++) sets.forEach((s) => s.cards[i] && take(s.cards[i]));
    if (out.length < 4) {
      sets = await Promise.all(picks.map((p) => fetchSet(p.handle, LEVELS)));
      for (let i = 0; out.length < SHOW && i < 16; i++) sets.forEach((s) => s.cards[i] && take(s.cards[i]));
      notes.push('Only a few designs match at this level, so we added a few more.');
    }
    $('[data-wpq-wait]').hidden = true;
    out.forEach((li) => grid.appendChild(li));
    if (!out.length) notes = ['Nothing matches yet. Try another pick, or browse all kits.'];
    if (notes.length) { note.textContent = notes.join(' '); note.hidden = false; }

    // "See all matches" → the first collection with the same filters
    const first = picks[0];
    const all = $('[data-wpq-all]');
    if (first) {
      const p = query(lv, placeFor === first && placeSet && placeSet.count >= 4 ? a.place : null);
      all.href = `/collections/${first.handle}?${p}`;
      all.hidden = false;
    }

    const summary = chips.join(' · ');
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Kit quiz': summary } }) }).catch(() => {});
    try { window.Shopify?.analytics?.publish?.('kit_quiz_completed', { answers: summary }); } catch (err) {}
  };

  show('who', false);
})();
